import { render, staticRenderFns } from "./EarlyClaimTable.vue?vue&type=template&id=0c2fa47d&scoped=true&"
import script from "./EarlyClaimTable.vue?vue&type=script&lang=js&"
export * from "./EarlyClaimTable.vue?vue&type=script&lang=js&"
import style0 from "./EarlyClaimTable.vue?vue&type=style&index=0&id=0c2fa47d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2fa47d",
  null
  
)

export default component.exports